import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterSortDropdownMenuLogic} from "./FilterSortDropdownMenu.logic";
import {DropdownFilterMenu} from "../../filters/dropdown-filter-menu/DropdownFilterMenu";
import {FilterSort} from "../filter-sort/FilterSort";

export const FilterSortDropdownMenu: VoidFunctionComponent = () => {
  const {label, onClickMenuToggleHandler, isActive, dropdownFilterMenuRef, isAvailable} = useFilterSortDropdownMenuLogic();
  if (!isAvailable) {
    return null;
  }
  return <DropdownFilterMenu
    ref={dropdownFilterMenuRef}
    {...{label, onClickMenuToggleHandler, isActive}}
    component={FilterSort}
  />;
}
